<script setup>
const props = defineProps({
  navigationItems: Array,
});

const data = reactive({
  active: false,
});

function toggleMenu() {
  data.active = !data.active;
}

function closeNavigation() {
  data.active = false;
}
</script>

<template>
  <header
    id="page-header"
    class="page-header fixed w-full top-0 left-0 right-0 h-60px lg:h-80px z-10 bg-black flex items-center"
  >
    <div class="w-full mx-auto px-sm sm:px-md md:px-lg xl:px-xl 2xl:px-2xl">
      <div class="flex justify-between items-center">
        <Logo />
        <Navigation
          :navigationItems="navigationItems"
          :active="data.active"
          @closeNav="closeNavigation"
        />
        <Hamburger @click="toggleMenu" :active="data.active" />
      </div>
    </div>
  </header>
</template>

<style></style>
